import { useCallback, useEffect } from "react";

import { URLS } from "globalConstants";
import { history } from "helpers";

const USER_KEY = "user";

const useCheckTokenChange = () => {
	const checkTokenChange = useCallback(e => {
		if (e.key === USER_KEY) {
			const oldValue =
				typeof e.oldValue === "string" && JSON.parse(e.oldValue);
			const newValue =
				typeof e.newValue === "string" && JSON.parse(e.newValue);
			if (
				oldValue &&
				newValue &&
				oldValue.access_token !== newValue.access_token
			) {
				if (newValue.isRefresh) {
					const { isRefresh, ...value } = newValue;
					localStorage.setItem(USER_KEY, JSON.stringify(value));
				} else {
					history.replace(URLS.logout);
				}
			}
		}
	}, []);

	useEffect(() => {
		window.addEventListener("storage", checkTokenChange);

		return () => {
			window.removeEventListener("storage", checkTokenChange);
		};
	}, [checkTokenChange]);
};

export default useCheckTokenChange;
